var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_vm._v("Copyright ©\t "),_c('span',[_c('time',{domProps:{"textContent":_vm._s(_vm.copyRightYear)}})]),_vm._v(" 上海荟医信息科技有限公司 All Rights Reserved. 沪ICP备16021696号")])}
var staticRenderFns = []

export { render, staticRenderFns }